import axios from "axios";

const instance = axios.create({
  baseURL: "https://stag.mmbaicindia.com/api/ApiCommonController/",
});

export default instance;
